import { Session } from "@chromia/ft4";

import { cChrDeposit } from "../../classes/ChrDeposit";
import { tAvailableFTokens, tAvailableUTokens, tDiscountPercent } from "../../interfaces/interfaces";
import { iChrBalance, iTypedGtxClient, iWithdrawAvailable, iWithdrawRequest, tStoreRecord } from "../../interfaces/chrInterfaces";
import { cChrPendingDeposit } from "../../classes/ChrPendingDeposit";
import { cChrItem } from "../../classes/cChrItem";
import { cAllInfo } from "../../classes/AllInfo";

export enum eChromiaActionTypes{
	CLEAR_STATE = 'CHR/CLEAR_STATE',
	SET_SESSION = 'CHR/SET_SESSION',
	SET_CHR_CLIENT_ADDR = 'CHR/SET_CHR_CLIENT_ADDR',
	SET_GTX_CLIENT = 'CHR/SET_GTX_CLIENT',
	// SET_DEPOSITS = 'CHR/SET_DEPOSITS',
	SET_IS_CHR_REGISTERED = 'CHR/SET_IS_CHR_REGISTERED',
	// SET_ITEM = 'CHR/SET_ITEM',
	SET_ITEMS = 'CHR/SET_ITEMS',
	// SET_END_TIME = 'CHR/SET_END_TIME',

	SET_ACTIVE_DEPOSIT = 'CHR/SET_ACTIVE_DEPOSIT',
	SET_PENDING_DEPOSIT = 'CHR/SET_PENDING_DEPOSIT',
	SET_WITHDRAW_REQUEST = 'CHR/SET_WITHDRAW_REQUEST',
	SET_WITHDRAW_AVAILABLE = 'CHR/SET_WITHDRAW_AVAILABLE',
	SET_ACTIVE_DEPOSITS = 'CHR/SET_ACTIVE_DEPOSITS',
	SET_PENDING_DEPOSITS = 'CHR/SET_PENDING_DEPOSITS',
	SET_WITHDRAW_REQUESTS = 'CHR/SET_WITHDRAW_REQUESTS',
	SET_AVAILABLE_WITHDRAWS = 'CHR/SET_AVAILABLE_WITHDRAWS',

	SET_ALL_INFO = 'CHR/SET_ALL_INFO',

	SET_TOKEN_BALANCES = 'CHR/SET_TOKEN_BALANCES',
    SET_CHR_NODE_URL = 'CHR/SET_CHR_NODE_URL',
}

export type tChromiaAction =
	iClearStateAction |
	iSetSessionAction |
	iSetChrClientAddrAction |
	iSetGtxClientAction |
	// iSetDepositsAction |
	iSetIsChrRegisteredAction |
	iSetItemsAction |
	// iSetEndTimeAction |

	iSetActiveDepositAction |
	iSetPendingDepositAction |
	iSetWithdrawRequestAction |
	iSetWithdrawAvailableAction |
	iSetPendingDepositsAction |
	iSetWithdrawRequestsAction |
	iSetAvailableWithdrawsAction |
	iSetActiveDepositsAction |
	
	iSetAllInfoAction |

	iSetTokenBalancesAction |
	iSetChrNodeUrlAction
;

interface iClearStateAction {
	type: eChromiaActionTypes.CLEAR_STATE
}

interface iSetSessionAction {
	type: eChromiaActionTypes.SET_SESSION,
	payload: Session
}

interface iSetChrClientAddrAction {
	type: eChromiaActionTypes.SET_CHR_CLIENT_ADDR,
	payload: string
}

interface iSetGtxClientAction {
	type: eChromiaActionTypes.SET_GTX_CLIENT,
	payload: iTypedGtxClient
}

/* interface iSetDepositsAction {
	type: eChromiaActionTypes.SET_DEPOSITS,
	payload: {
		percent: tDiscountPercent,
		deposits: cChrDeposit[]
	}
} */

interface iSetIsChrRegisteredAction {
	type: eChromiaActionTypes.SET_IS_CHR_REGISTERED,
	payload: boolean
}

interface iSetItemsAction {
	type: eChromiaActionTypes.SET_ITEMS,
	payload: tStoreRecord<cChrItem>
}

/* interface iSetEndTimeAction {
	type: eChromiaActionTypes.SET_END_TIME,
	payload: {
		fToken: tAvailableFTokens,
		uToken: tAvailableUTokens,
		percent: tDiscountPercent,
		endTime: number
	}
} */


interface iSetActiveDepositAction {
	type: eChromiaActionTypes.SET_ACTIVE_DEPOSIT,
	payload: {
		fToken: tAvailableFTokens,
		uToken: tAvailableUTokens,
		percent: tDiscountPercent,
		deposit: cChrDeposit | null
	}
}

interface iSetPendingDepositAction {
	type: eChromiaActionTypes.SET_PENDING_DEPOSIT,
	payload: {
		fToken: tAvailableFTokens,
		uToken: tAvailableUTokens,
		percent: tDiscountPercent,
		deposit: cChrPendingDeposit | null
	}
}

interface iSetWithdrawRequestAction {
	type: eChromiaActionTypes.SET_WITHDRAW_REQUEST,
	payload: {
		fToken: tAvailableFTokens,
		uToken: tAvailableUTokens,
		percent: tDiscountPercent,
		request: iWithdrawRequest | null
	}
}

interface iSetWithdrawAvailableAction {
	type: eChromiaActionTypes.SET_WITHDRAW_AVAILABLE,
	payload: {
		fToken: tAvailableFTokens,
		uToken: tAvailableUTokens,
		percent: tDiscountPercent,
		amounts: iWithdrawAvailable | null
	}
}

interface iSetActiveDepositsAction {
	type: eChromiaActionTypes.SET_ACTIVE_DEPOSITS,
	payload: tStoreRecord<cChrDeposit | null>
}

interface iSetPendingDepositsAction {
	type: eChromiaActionTypes.SET_PENDING_DEPOSITS,
	payload: tStoreRecord<cChrPendingDeposit | null>
}

interface iSetWithdrawRequestsAction {
	type: eChromiaActionTypes.SET_WITHDRAW_REQUESTS,
	payload: tStoreRecord<iWithdrawRequest | null>
}

interface iSetAvailableWithdrawsAction {
	type: eChromiaActionTypes.SET_AVAILABLE_WITHDRAWS,
	payload: tStoreRecord<iWithdrawAvailable | null>
}

interface iSetAllInfoAction {
	type: eChromiaActionTypes.SET_ALL_INFO,
	payload: tStoreRecord<cAllInfo | null>
}

interface iSetTokenBalancesAction {
	type: eChromiaActionTypes.SET_TOKEN_BALANCES,
	payload: iChrBalance[]
}

interface iSetChrNodeUrlAction {
    type: eChromiaActionTypes.SET_CHR_NODE_URL;
    payload: string;
}